import React from 'react'
import {BrowserRouter, Route, Routes, Navigate, Outlet} from 'react-router-dom'
import Layout from 'src/Layout'
import Main from 'src/views/Main'
import Cancel from 'src/views/Cancel'
import Terms from 'src/views/Terms'
import Center from 'src/views/Support'
import Health from 'src/views/Letter/Health'
import UserPage from "src/views/UserPage";
import Login from "src/views/Login"
import {GoogleReCaptcha} from "react-google-recaptcha-v3";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {RecapAuthToken, RefreshRecapAuthToken} from "src/store/recoil/common";
import {TermsDocument} from "src/component/Notice/yuseoung-gu/TermsDocument";
import Join from 'src/views/Join'

const LayoutWrapper = () => (
    <Layout>
      <Outlet />
    </Layout>
);
const App = () => {
  const setAuthToken = useSetRecoilState(RecapAuthToken)
  const refreshReCaptcha = useRecoilValue(RefreshRecapAuthToken)
  function handleVerify(value:any) {
    setAuthToken(value)
  }

  return (
      <BrowserRouter>
        <Routes>
          <Route element={<LayoutWrapper />}>
            <Route path='/' element={<Main />} />
            <Route path='/healthExample/:idx' element={<Health />} />
            <Route path='/center' element={<Center />} />
            <Route path='/cancel' element={<Cancel />} />
            <Route path='/notice' element={<Center />} />
            <Route path="/join" element={<Join />} />
            <Route path='/news' element={<Center />} />
            <Route path='/notice/detail/:idx' element={<Center />} />
            <Route path='/terms' element={<Navigate to='/terms/0/1' />} />
            <Route path='/terms/:telecom' element={<Terms />} />
            <Route path='/terms/:telecom/:terms' element={<Terms />} />
            <Route path='/faq' element={<Center />} />
            <Route path='/refund' element={<Center />} />
            <Route path='/inquiry' element={<Center />} />
            <Route path='/login' element={<Login />} />
            <Route path='/userPage/main' element={<UserPage />} />
            <Route path='/userPage/letter/health' element={<UserPage />} />
            <Route path='/userPage/letter/life' element={<UserPage />} />
            <Route path='/userPage/letter/health/detail/:idx' element={<UserPage />} />
            <Route path='/userPage/letter/life/detail/:idx' element={<UserPage />} />
            <Route path='/userPage/fortune' element={<UserPage />} />
          </Route>
          <Route path="/notice/detail/yuseong/:id" element={<TermsDocument />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <GoogleReCaptcha onVerify={handleVerify} refreshReCaptcha={refreshReCaptcha} />
      </BrowserRouter>
  )
}
export default App
